export const windowGlobal = () => window
